import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './clientCreatePkb.module.css';

import HookForm from '../../../../components/HookForm/HookForm';
import Button from '../../../../components/Button/Button';
import Hint from '../../../../components/Hint';

import pkbRequestConsent from '../../../../api/clients/pkbRequestConsent';
import pkbPollConsent from '../../../../api/clients/pkbPollConsent';
import phoneBelongsIinValidate from '../../../../api/bmg/phoneBelongsIinValidate';
import { BMG_PHONE_MISMATCH_MESSAGE, BMG_UNAVAILABLE_MESSAGE } from '../../../../utils/clientContact';
import alert from '../../../../helpers/alert';
import { phone as phoneMask, iin as iinMask } from '../../../../constants/mask';

// Ð¢Ð ÐÐÐ v7: ÐÐÐ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð½Ðµ ÑÐ°ÑÐµ Ð¾Ð´Ð½Ð¾Ð³Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð² 10 ÑÐµÐºÑÐ½Ð´ Ð½Ð° ÐÐÐ,
// Ð¸Ð½Ð°ÑÐµ GBDFL_KDP_ERROR Â«KDP: too many requestsÂ».
const POLL_INTERVAL_MS = 11000;
// Ð¡ÑÐ¾Ð»ÑÐºÐ¾ Ð¶Ð¸Ð²ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð² ÐÐÐ â ÑÑÐ¾Ñ Ð¶Ðµ ÑÑÐ¾Ðº Ð½Ð°Ð¿ÐµÑÐ°ÑÐ°Ð½ Ð² Ð¡ÐÐ¡ ÐºÐ»Ð¸ÐµÐ½ÑÑ.
// ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð±Ð¾Ð»ÑÑÐµ Ð½ÐµÐ»ÑÐ·Ñ: ÐºÐ»Ð¸ÐµÐ½Ñ Ð¾ÑÐ²ÐµÑÐ°ÐµÑ Â«Ð² ÑÑÐ¾ÐºÂ» Ð¿Ð¾ Ð½Ð°ÑÐµÐ¼Ñ ÑÐ°Ð¹Ð¼ÐµÑÑ Ð¸ Ð¿ÑÐ¾Ð¼Ð°ÑÐ¸Ð²Ð°ÐµÑÑÑ.
const CONSENT_WINDOW_SECONDS = 5 * 60;

const STATUS_LABELS = {
  Pending: 'ÐÐ¶Ð¸Ð´Ð°ÐµÐ¼ Ð¾ÑÐ²ÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
  Created: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¾',
  Declined: 'ÐÐ»Ð¸ÐµÐ½Ñ Ð¾ÑÐºÐ°Ð·Ð°Ð»ÑÑ Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð¸ÑÑ Ð´Ð¾ÑÑÑÐ¿ Ðº Ð´Ð°Ð½Ð½ÑÐ¼',
  Timeout: 'ÐÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð» Ð½Ð° SMS Ð·Ð° Ð¾ÑÐ²ÐµÐ´ÑÐ½Ð½ÑÐµ 5 Ð¼Ð¸Ð½ÑÑ',
  NoPhone: 'ÐÐ¾Ð¼ÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½ Ð² ÐÐ°Ð·Ðµ Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½ÑÑ Ð³ÑÐ°Ð¶Ð´Ð°Ð½',
  Error: 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð»ÑÑÐ¸ÑÑ Ð´Ð°Ð½Ð½ÑÐµ',
};

const IconId = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="8.5" cy="10.5" r="1.8" stroke="currentColor" strokeWidth="1.4" />
    <path d="M5.5 15.5c.6-1.6 1.9-2.4 3-2.4s2.4.8 3 2.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M14 9h4M14 12h4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const IconSms = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 5.5C4 4.7 4.7 4 5.5 4h13c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5H9l-3.6 3.2c-.5.4-1.2.1-1.2-.6V15h-.7C4.7 15 4 14.3 4 13.5v-8Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <circle cx="8.3" cy="9.5" r="1" fill="currentColor" />
    <circle cx="12" cy="9.5" r="1" fill="currentColor" />
    <circle cx="15.7" cy="9.5" r="1" fill="currentColor" />
  </svg>
);

const IconAlert = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
    <path d="M12 7.5v5.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="12" cy="16.3" r="1.1" fill="currentColor" />
  </svg>
);

const IconRefresh = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path
      d="M20 12a8 8 0 1 1-2.6-5.9M20 4v5h-5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const howItWorksHint = (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 10, minWidth: 220 }}>
    <div style={{ display: 'flex', gap: 8 }}>
      <span style={{ fontWeight: 700, color: '#b8894f' }}>1.</span>
      <span>Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÐÐÐ Ð¸ ÑÐµÐ»ÐµÑÐ¾Ð½ ÐºÐ»Ð¸ÐµÐ½ÑÐ°</span>
    </div>
    <div style={{ display: 'flex', gap: 8 }}>
      <span style={{ fontWeight: 700, color: '#b8894f' }}>2.</span>
      <span>ÐÐ»Ð¸ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÐµÑ Ð¿Ð¾ SMS Ð¾Ñ Â«1414Â» (5 Ð¼Ð¸Ð½ÑÑ)</span>
    </div>
    <div style={{ display: 'flex', gap: 8 }}>
      <span style={{ fontWeight: 700, color: '#b8894f' }}>3.</span>
      <span>ÐÐ°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿Ð¾Ð»ÑÑÐµÐ½Ñ</span>
    </div>
  </div>
);

const Steps = ({ active }) => (
  <div className={styles.steps}>
    <div className={`${styles.step} ${active === 1 ? styles.active : ''}`}>
      <span className={styles.stepDot} />
      ÐÐ°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°
    </div>
    <div className={styles.stepLine} />
    <div className={`${styles.step} ${active === 2 ? styles.active : ''}`}>
      <span className={styles.stepDot} />
      SMS-ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ
    </div>
  </div>
);

// onCreated/onManual Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÑÑ Ð²ÑÑÑÐ¾Ð¸ÑÑ ÑÑÐ¾Ñ ÑÐºÑÐ°Ð½ Ð² Ð¼Ð¾Ð´Ð°Ð»ÐºÑ (ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°
// Ð¿ÑÑÐ¼Ð¾ Ð²Ð½ÑÑÑÐ¸ Ð´ÑÑÐ³Ð¾Ð³Ð¾ ÑÐ»Ð¾Ñ) â Ð±ÐµÐ· Ð½Ð¸Ñ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ ÐºÐ°Ðº ÑÐ°Ð¼Ð¾ÑÑÐ¾ÑÑÐµÐ»ÑÐ½Ð°Ñ ÑÑÑÐ°Ð½Ð¸ÑÐ°.
const ClientCreatePkb = ({ onCreated, onManual }) => {
  const navigate = useNavigate();
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [phase, setPhase] = useState('form'); // form | waiting | error
  const [consentRequestId, setConsentRequestId] = useState(null);
  const [checkStatus, setCheckStatus] = useState('Pending');
  const [errorMessage, setErrorMessage] = useState('');
  const [secondsLeft, setSecondsLeft] = useState(CONSENT_WINDOW_SECONDS);
  const windowSecondsRef = useRef(CONSENT_WINDOW_SECONDS);
  const [simulated, setSimulated] = useState(false);

  const pollTimerRef = useRef(null);
  const countdownTimerRef = useRef(null);

  const clearTimers = () => {
    if (pollTimerRef.current) clearInterval(pollTimerRef.current);
    if (countdownTimerRef.current) clearInterval(countdownTimerRef.current);
    pollTimerRef.current = null;
    countdownTimerRef.current = null;
  };

  useEffect(() => clearTimers, []);

  const finishWith = (result) => {
    clearTimers();
    if (result.status === 'Created') {
      alert.success('ÐÐ»Ð¸ÐµÐ½Ñ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾Ð·Ð´Ð°Ð½');
      if (onCreated) {
        onCreated(result.clientId);
        return;
      }
      navigate(`/client/${result.clientId}/main-data`);
      return;
    }
    setPhase('error');
    setErrorMessage(result.errorMessage || STATUS_LABELS[result.status] || 'ÐÑÐ¸Ð±ÐºÐ°');
  };

  const poll = async (id) => {
    try {
      const res = await pkbPollConsent(id);
      const status = res?.data?.status || 'Pending';
      setCheckStatus(status);
      if (status !== 'Pending') {
        finishWith(res.data);
      }
    } catch (e) {
      // ÑÐµÑÐµÐ²Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ° Ð¾Ð´Ð½Ð¾Ð³Ð¾ Ð¾Ð¿ÑÐ¾ÑÐ° â Ð½Ðµ Ð¿ÑÐµÑÑÐ²Ð°ÐµÐ¼ Ð¾Ð¶Ð¸Ð´Ð°Ð½Ð¸Ðµ, Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐµÐ¼ Ð½Ð° ÑÐ»ÐµÐ´ÑÑÑÐµÐ¼ ÑÐ¸ÐºÐµ
    }
  };

  const startWaiting = (id, windowSeconds) => {
    windowSecondsRef.current = windowSeconds || CONSENT_WINDOW_SECONDS;

    setConsentRequestId(id);
    setCheckStatus('Pending');
    setSecondsLeft(windowSecondsRef.current);
    setPhase('waiting');

    poll(id);
    pollTimerRef.current = setInterval(() => poll(id), POLL_INTERVAL_MS);
    countdownTimerRef.current = setInterval(() => {
      setSecondsLeft((prev) => Math.max(0, prev - 1));
    }, 1000);
  };

  const submit = async () => {
    const iin = (values.iin || '').replace(/\D/g, '');
    const phone = (values.phoneNumber || '').replace(/\D/g, '');

    if (iin.length !== 12) {
      return alert.error('ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾ÑÑÑ ÐÐÐ');
    }
    if (!phone) {
      return alert.error('Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°');
    }

    setLoading(true);

    // ÐÑÐ¾Ð²ÐµÑÐºÐ° ÐÐÐ Ð·Ð´ÐµÑÑ, Ð° Ð½Ðµ Ð½Ð° ÑÐ°Ð³Ðµ 4 ÑÐ´ÐµÐ»ÐºÐ¸: ÐºÐ»Ð¸ÐµÐ½Ñ, ÑÐ¾Ð·Ð´Ð°Ð½Ð½ÑÐ¹ ÑÐµÑÐµÐ· eGov,
    // Ð´Ð¾ ÑÑÐ¾Ð³Ð¾ ÐµÑ Ð¾Ð±ÑÐ¾Ð´Ð¸Ð» Ð¸ ÑÐ·Ð½Ð°Ð²Ð°Ð» Ð¾ ÑÑÐ¶Ð¾Ð¼ Ð½Ð¾Ð¼ÐµÑÐµ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÐµÑÐµÐ´ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸ÐµÐ¼
    // ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ð¹ (ÑÐ´ÐµÐ»ÐºÐ° 191883). Ð ÑÑÐ½Ð°Ñ ÑÐ¾ÑÐ¼Ð° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ ÑÐ°Ðº Ð¶Ðµ.
    try {
      const isPhoneBelongsToClient = await phoneBelongsIinValidate({ phone, iin });
      if (!isPhoneBelongsToClient) {
        setLoading(false);
        return alert.error(BMG_PHONE_MISMATCH_MESSAGE);
      }
    } catch (e) {
      setLoading(false);
      return alert.error(BMG_UNAVAILABLE_MESSAGE);
    }

    try {
      const res = await pkbRequestConsent({
        iin,
        phone,
      });
      setSimulated(!!res.data.simulated);
      startWaiting(res.data.consentRequestId, res.data.expiresInSeconds);
    } catch (e) {
      alert.error(e?.response?.data?.errorMessage || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð·Ð°Ð¿ÑÐ¾Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ');
    } finally {
      setLoading(false);
    }
  };

  const formInputs = [
    {
      name: 'iin',
      label: 'ÐÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
      placeholder: '_ _ _ _ _ _ _ _ _ _ _ _',
      mask: iinMask,
      rules: { required: true },
    },
    {
      name: 'phoneNumber',
      label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
      placeholder: '+7(___) ___-__-__',
      mask: phoneMask,
      rules: { required: true },
    },
  ];

  const goManual = () => (onManual ? onManual() : navigate('/client/create'));

  const progressPercent = Math.round(
    ((windowSecondsRef.current - secondsLeft) / windowSecondsRef.current) * 100
  );
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = String(secondsLeft % 60).padStart(2, '0');

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <IconId />
        </div>
        <div>
          <p className={styles.headerTitle}>
            ÐÐ¾Ð»ÑÑÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ñ eGov
            <Hint text={howItWorksHint} />
          </p>
          {/* <p className={styles.headerSubtitle}>Ð¡Ð¾Ð·Ð´Ð°Ð´Ð¸Ð¼ ÐºÐ°ÑÑÐ¾ÑÐºÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿Ð¾ÑÐ»Ðµ ÐµÐ³Ð¾ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð¿Ð¾ SMS</p> */}
        </div>
      </div>

      <Steps active={phase === 'form' ? 1 : 2} />

      {phase === 'form' && (
        <div className={styles.card}>
          {loading && (
            <div className={styles.formOverlay}>
              <span className={styles.formSpinner} />
              <p className={styles.formOverlayText}>ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ Ð·Ð°Ð¿ÑÐ¾Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñâ¦</p>
            </div>
          )}
          <div className={styles.forms}>
            <HookForm
              inputs={formInputs}
              grid={{ display: 'grid', rowGap: '18px', margin: 0 }}
              style={{ margin: 0, padding: 0, backgroundColor: 'transparent' }}
              onValuesChange={setValues}
            />
            {/* <p className={styles.fieldHint}>Ð¢ÐµÐ»ÐµÑÐ¾Ð½ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑÑ ÐºÐ°Ðº ÐºÐ¾Ð½ÑÐ°ÐºÑÐ½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð² CRM</p> */}
            <div className={styles.actions}>
              <Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð·Ð°Ð¿ÑÐ¾Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ" fill full onClick={submit} disabled={loading} />
              <span className={styles.manualLink} onClick={goManual}>
                ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð²ÑÑÑÐ½ÑÑ
              </span>
            </div>
          </div>
        </div>
      )}

      {phase === 'waiting' && (
        <div className={styles.waitingCard}>
          <div className={styles.spinnerWrap}>
            <span className={styles.spinnerRing} />
            <span className={styles.spinnerIcon}>
              <IconSms />
            </span>
          </div>
          <p className={styles.waitingTitle}>{STATUS_LABELS[checkStatus] || 'ÐÐ¶Ð¸Ð´Ð°ÐµÐ¼ Ð¾ÑÐ²ÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°'}</p>
          <p className={styles.waitingSubtitle}>
            {simulated
              ? 'Ð¢ÐµÑÑÐ¾Ð²ÑÐ¹ ÐºÐ¾Ð½ÑÑÑ: ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑÑ ÑÐ°Ð¼Ð¾, Ð¾ÑÐ²ÐµÑÐ°ÑÑ Ð½Ð° SMS Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾'
              : 'ÐÐ»Ð¸ÐµÐ½Ñ Ð¾ÑÐ²ÐµÑÐ°ÐµÑ 511 Ð½Ð° SMS Ð¾Ñ Â«1414Â» â Ñ Ð½ÐµÐ³Ð¾ 5 Ð¼Ð¸Ð½ÑÑ'}
          </p>

          <div className={styles.countdown}>
            {minutes}:{seconds}
          </div>
          <p className={styles.countdownLabel}>Ð¾ÑÑÐ°Ð»Ð¾ÑÑ Ð²ÑÐµÐ¼ÐµÐ½Ð¸</p>

          <div className={styles.progressTrack}>
            <div className={styles.progressFill} style={{ width: `${progressPercent}%` }} />
          </div>

          <button className={styles.refreshButton} onClick={() => poll(consentRequestId)}>
            <IconRefresh />
            ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ ÑÑÐ°ÑÑÑ
          </button>
        </div>
      )}

      {phase === 'error' && (
        <div className={styles.errorCard}>
          <div className={styles.errorIcon}>
            <IconAlert />
          </div>
          <p className={styles.errorTitle}>ÐÐµ Ð¿Ð¾Ð»ÑÑÐ¸Ð»Ð¾ÑÑ ÑÐ¾Ð·Ð´Ð°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°</p>
          <p className={styles.errorMessage}>{errorMessage}</p>
          <div className={styles.errorActions}>
            <Button text="ÐÐ¾Ð¿ÑÐ¾Ð±Ð¾Ð²Ð°ÑÑ ÐµÑÑ ÑÐ°Ð·" fill full onClick={() => setPhase('form')} />
            <span className={styles.manualLink} onClick={goManual}>
              ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð²ÑÑÑÐ½ÑÑ
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientCreatePkb;
